import { render, staticRenderFns } from "./FilterAge.vue?vue&type=template&id=44427b93&lang=pug&"
import script from "./FilterAge.vue?vue&type=script&lang=js&"
export * from "./FilterAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports